export interface IMockOrder {
    orderId: string;
    orderStatus: 'booked' | 'dispatched' | 'in-transit' | 'delivered';
    orderType: string;
    carrierName: string;
    trackingId?: string;
    customerName: string;
    shipperCity: string;
    shipperPostal?: string;
    consigneeCity: string;
    consigneePostal?: string;
    pickupDate: string;
    deliveredDate: string;
    lastUpdate: string;
    coordinates: [number, number];
    predictiveLocationIndex?: 'On Track' | 'Running Late' | 'Delayed' | 'On Truck';
}

export const TRACK_FILTER_SERVICE_ARR = [
    { value: 'ftl', label: 'FTL' },
    { value: 'ltl', label: 'LTL' },
];

export const TRACK_SORT_BY = [
    { label: 'Last Update Time', value: 'lastUpdatedAt' },
    { label: 'Pickup Date', value: 'pickupDate' },
    { label: 'Estimated Delivery Time', value: 'estDeliveryDate' },
];

export const MOCK_ORDERS: IMockOrder[] = [
    {
        orderId: 'WAL-20260310-001',
        orderStatus: 'dispatched',
        orderType: 'ftl',
        carrierName: 'Purolator',
        trackingId: 'PUR-20260310-001',
        customerName: 'Maple Logistics Inc.',
        shipperCity: 'Toronto',
        shipperPostal: 'M5V 3C6',
        consigneeCity: 'Montreal',
        consigneePostal: 'H3B 4W8',
        pickupDate: 'Mar 12th at 9:00AM',
        deliveredDate: '',
        lastUpdate: '',
        coordinates: [-79.3832, 43.6532],
        predictiveLocationIndex: 'On Track',
    },
    {
        orderId: 'WAL-20260310-002',
        orderStatus: 'dispatched',
        orderType: 'ltl',
        carrierName: 'Day Ross',
        trackingId: '',
        customerName: 'Ontario Fresh Foods',
        shipperCity: 'Mississauga',
        shipperPostal: 'L5B 2T4',
        consigneeCity: 'Halifax',
        consigneePostal: 'B3J 1R5',
        pickupDate: 'Mar 11th at 10:00AM',
        deliveredDate: '',
        lastUpdate: '',
        coordinates: [-79.6441, 43.589],
    },
    {
        orderId: 'WAL-20260310-003',
        orderStatus: 'booked',
        orderType: 'volume_ltl',
        carrierName: 'XPO Logistics',
        trackingId: '',
        customerName: 'Northern Supply Co.',
        shipperCity: 'Ottawa',
        shipperPostal: 'K1A 0B1',
        consigneeCity: 'Calgary',
        consigneePostal: 'T2P 1J9',
        pickupDate: 'Mar 14th',
        deliveredDate: '',
        lastUpdate: '',
        coordinates: [-75.6972, 45.4215],
        predictiveLocationIndex: 'Running Late',
    },
    {
        orderId: 'WAL-20260310-004',
        orderStatus: 'in-transit',
        orderType: 'ftl',
        carrierName: 'Saia Freight',
        trackingId: 'SAIA-78901',
        customerName: 'Pacific Traders Ltd.',
        shipperCity: 'Vancouver',
        shipperPostal: 'V6B 1A1',
        consigneeCity: 'Boston',
        consigneePostal: 'MA 02101',
        pickupDate: 'Mar 10th',
        deliveredDate: '',
        lastUpdate: 'Today at 10:45 AM',
        coordinates: [-123.1207, 49.2827],
        predictiveLocationIndex: 'On Truck',
    },
    {
        orderId: 'WAL-20260310-005',
        orderStatus: 'in-transit',
        orderType: 'ltl',
        carrierName: 'Old Dominion',
        trackingId: 'OD-456123',
        customerName: 'Midwest Goods Corp.',
        shipperCity: 'Chicago',
        shipperPostal: 'IL 60601',
        consigneeCity: 'New York',
        consigneePostal: 'NY 10001',
        pickupDate: 'Mar 9th',
        deliveredDate: '',
        lastUpdate: 'Today at 9:30 AM',
        coordinates: [-87.6298, 41.8781],
        predictiveLocationIndex: 'Delayed',
    },
    {
        orderId: 'WAL-20260310-006',
        orderStatus: 'in-transit',
        orderType: 'volume_ltl',
        carrierName: 'Estes Express',
        trackingId: '',
        customerName: 'Atlantic Imports LLC',
        shipperCity: 'Denver',
        shipperPostal: 'CO 80202',
        consigneeCity: 'Houston',
        consigneePostal: 'TX 77001',
        pickupDate: 'Mar 8th',
        deliveredDate: '',
        lastUpdate: 'Yesterday at 3:15 PM',
        coordinates: [-104.9903, 39.7392],
        predictiveLocationIndex: 'On Track',
    },
    {
        orderId: 'WAL-20260310-007',
        orderStatus: 'delivered',
        orderType: 'ltl',
        carrierName: 'R+L Carriers',
        trackingId: 'RL-99012',
        customerName: 'West Coast Mfg.',
        shipperCity: 'Portland',
        shipperPostal: 'OR 97201',
        consigneeCity: 'Philadelphia',
        consigneePostal: 'PA 19103',
        pickupDate: 'Mar 6th',
        deliveredDate: 'Mar 10th',
        lastUpdate: '',
        coordinates: [-122.6765, 45.5231],
    },
    {
        orderId: 'WAL-20260310-008',
        orderStatus: 'delivered',
        orderType: 'ftl',
        carrierName: 'FedEx Freight',
        trackingId: 'FX-334567',
        customerName: 'Gulf Trading Co.',
        shipperCity: 'Toronto',
        shipperPostal: 'M5H 2N2',
        consigneeCity: 'Beaumont',
        consigneePostal: 'TX 77701',
        pickupDate: 'Mar 5th',
        deliveredDate: 'Mar 9th',
        lastUpdate: '',
        coordinates: [-79.3832, 43.7532],
    },
];
